<template>
  <section class="asuransi-container" data-aos="fade-left" data-aos-delay="300">
    <div class="container pt-0">
      <div class="section-title text-center">
        <div class="row">
          <div class="col-md-12 col-md-offset-2 pb-30">
            <h2 class="mt-0 line-height-1 text-uppercase">
              Partner
              <span class="text-theme-colored">Kami</span>
            </h2>
          </div>
        </div>
      </div>
      <i v-if="show_loading" class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
      <div v-else-if="assurances.length < 1" class="alert alert-danger">No data</div>
      <carousel
        v-else
        :autoplay="true"
        :nav="false"
        :items="(assurances.length > 4) ? 4 : assurances.length"
        :loop="false"
        :dots="false"
        :responsive="{
				  	1024:{items:4},
				  	639:{items:3},
				  	0:{items:2}
				  }"
      >
        <div :key="'assurance-' + item.id" v-for="item in assurances" class="asuransi-cols">
          <div class="asuransi-row">
            <router-link :to="{ path: '/asuransi/'+item.id }">
              <img
                style="height: 100px; object-fit: contain; display:block; border-radius: 5px 5px 0px 0px"
                v-bind:src="(JSON.parse(item.meta).meta_picture == null) ? 'http://placehold.it/200x200' : JSON.parse(item.meta).meta_picture"
                alt
                class="img-responsive"
              />
            </router-link>
            <router-link
              v-if="item.title.length > 9"
              :to="{ path: '/asuransi/'+item.id }"
              class="asuransi-title"
            >
              <h5 class="mt-15 mb-10 text-center">{{ item.title.substr(0, 10) }}...</h5>
            </router-link>
            <router-link
              v-if="item.title.length < 10"
              :to="{ path: '/asuransi/'+item.id }"
              class="asuransi-title"
            >
              <h5 class="mt-15 text-center">{{ item.title.substr(0, 10) }}</h5>
            </router-link>
            <div class="asuransi-desc pt-5 pb-15 pl-15 pr-15">
              <!-- <div class="text-center" v-html="item.description"></div> -->
              <b-link
                :to="{ path: '/asuransi/'+item.id }"
                class="btn btn-border btn-block btn-circled btn-transparent mt-10"
              >Readmore</b-link>
            </div>
          </div>
        </div>
      </carousel>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
import api from "../../services/api";

export default {
  components: { carousel },
  data() {
    return {
      show_loading: false,
      assurances: [],
    };
  },
  mounted() {
    this.getAssurance();
  },
  methods: {
    getAssurance() {
      this.show_loading = true;
      api
        .post(api.route.get.assurance)
        .then((res) => {
          let status = res.status;
          if (status) this.assurances = res.data;
          this.show_loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.show_loading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/home/HomeAsuransi.vue